import type { HashtagListResponsePage } from './hashtagListResponsePage';

export interface HashtagListResponse {
  code?: string;
  message?: string;
  page?: HashtagListResponsePage;
  success?: boolean;
}
